import { BadgeCheck } from "lucide-react";

// Verified Coach feature is saved but inactive. Set to true to activate badges.
export const VERIFIED_BADGE_ENABLED = false;

export const VerifiedBadge = ({ testId, light = false }) => {
  if (!VERIFIED_BADGE_ENABLED) return null;
  return (
    <span
      data-testid={testId}
      title="Verified by GolfStart"
      aria-label="Verified Coach"
      className={`inline-flex items-center gap-1 align-middle font-sans text-[10px] tracking-[0.2em] uppercase whitespace-nowrap ${
        light ? "text-cream-light/90" : "text-forest-muted"
      }`}
    >
      <BadgeCheck className="h-4 w-4 shrink-0 text-[#1D9BF0]" strokeWidth={2} />
      Verified Coach
    </span>
  );
};
